import type { GraphViewResponseBody } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import deepEqual from 'react-fast-compare';

export const fetchViews: GraphCommandFactory = (cmdContext) => async () => {
  const views = await cmdContext.api.request<GraphViewResponseBody[]>({
    url: '/graphs/views',
    method: 'GET',
  });

  cmdContext.updateState((draft) => {
    if (!deepEqual(draft.loadViewDialog.views, views)) {
      draft.loadViewDialog.views = views;
    }

    if (draft.loadViewDialog.views.length === 0) {
      draft.loadViewDialog.open = false;
    }
  });
};
